<template>
  <div class="organization-tile" @click="gotoOrganization($event, organization)" v-loading="loading">
    <div class="tags">
      <el-tag size="small" type="success" v-if="organization.invite">Invite</el-tag>
      <el-tag size="small" type="info" v-if="!organization.invite && organization.pending">Pending</el-tag>
    </div>
    <div class="org-logo"
      :style="{backgroundImage: 'url(' + (organization.logo ? organization.logo.absolutePath : this.logo) + ')'}">
    </div>

    <div class="footer">
      <div class="org-info">
        <p>{{ organization.name }}</p>
      </div>
      <div class="controls">
        <div class="invited" v-if="organization.invite">
          <el-button type="text" icon="el-icon-close" @click="$emit('cancelMembership', organization)">
            Decline
          </el-button>
          <el-button type="text" icon="el-icon-check" @click="$emit('acceptMembership', organization)">
            Accept
          </el-button>
        </div>
        <el-button type="text" icon="el-icon-close" v-if="!organization.invite && organization.pending" @click="$emit('cancelMembership', organization)"></el-button>

        <el-button type="text" v-if="!organization.member" @click="$emit('requestMembership', organization)">
          <fa icon="user-plus" />
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/assets/logo_all_blue.png'
export default {
  name: 'UserTile',
  props: {
    loading: {
      type: Boolean,
      required: false
    },
    organization: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      logo: Logo
    }
  },
  methods: {
    gotoOrganization (e, organization) {
      if (e.target.nodeName === 'BUTTON' || e.target.nodeName === 'SPAN') {
        return
      }
      this.$router.push({ name: 'Organization', params: { orgId: organization.id } })
    }
  }
}
</script>

<style lang="scss" scoped>

  .footer {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    -webkit-box-shadow: 0px -3px 30px 0px rgba($text-light,0.075);
    -moz-box-shadow: 0px -3px 30px 0px rgba($text-light,0.075);
    box-shadow: 0px -3px 30px 0px rgba($text-light,0.075);
    background-color: white;
  }

  .tags {
    position: absolute;
    left: 10px;
    top: 10px;
  }

  .controls {

    padding-right: 10px;

    button {
      font-size: 14px;
    }

    .invited {
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        color: $green;
        flex: 4;
        padding-right: 10px;
        text-align: right;
        margin: 0;
      }

      button {
        flex: 1;
        margin-left: 10px;
      }
    }
  }

  .org-logo {
    flex: 1;
    width: 100%;
    height: auto;
    background-color: transparent;
    background-size: auto 35px;
    background-repeat: no-repeat;
    background-position: center center;
    display: block;
  }

  .organization-tile {
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    margin: 10px .66%;
    width: calc((100vw - 277px) / 5);
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fdfdfd;
    transition: background-color .2s ease-out;


    @include breakpoint (xl) {
      width: calc((100vw - 277px) / 5);
    }

    @include breakpoint (lg) {
      width: calc((100vw - 277px) / 4);
    }

    @include breakpoint (md-lg) {
      width: calc((100vw - 277px) / 3);
    }


    @include breakpoint (md) {
      width: calc((100vw - 277px) / 2);
    }

    @include breakpoint (xs-sm) {
      width: 50%;
    }

    @include breakpoint (xs) {
      width: 100%;
    }

    
    &:hover {
      background-color: $bg;
    }

    .org-info {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      align-self: stretch;
      width: 50%;
      padding-left: 10px;
    }

    p {
      color: $text;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/user/OrganizationTile.vue